import { render, staticRenderFns } from "./SavingsAccount.vue?vue&type=template&id=489b8ad9&"
import script from "./SavingsAccount.vue?vue&type=script&lang=js&"
export * from "./SavingsAccount.vue?vue&type=script&lang=js&"
import style0 from "./SavingsAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489b8ad9')) {
      api.createRecord('489b8ad9', component.options)
    } else {
      api.reload('489b8ad9', component.options)
    }
    module.hot.accept("./SavingsAccount.vue?vue&type=template&id=489b8ad9&", function () {
      api.rerender('489b8ad9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/SavingsAccount.vue"
export default component.exports